export const focusGlow = [
  // base
  'focus:outline-hidden',
  // border color
  'focus:border-primary',
  // glow effect
  'focus:shadow-glow',
];

export const focusNoGlow = [
  // base
  'focus:outline-hidden',
];
